import { LineChart } from '@mui/x-charts/LineChart';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';

export const MaterialsLineChartTwo = ({ data, totalCount, text, textTop }) => {
  const { t } = useTranslation();

  // Преобразуем данные за 2023 год в массивы для меток (месяцев) и значений
  const months = Object.keys(data).map(month => t(month));
  const values = Object.values(data);

  return (
    <div className="statistics-line-chart-block">
      <div className="statistics-line-chart-block-top">
        <div className="statistics-line-chart-text">
          <span className="statistics-line-chart-count">
            {totalCount} {t(textTop)}
          </span>
          <span className="statistics-line-chart-count-text">{t(text)}</span>
        </div>
      </div>

      {totalCount ? (
        <LineChart
          maxWidth={500}
          height={300}
          series={[
            {
              data: values,
              yAxisKey: 'leftAxisId',
              color: 'rgba(169, 186, 245, 1)', // Установка цвета линии
            },
          ]}
          xAxis={[{ scaleType: 'point', data: months }]}
          yAxis={[{ id: 'leftAxisId' }]}
        />
      ) : (
        <p className="statistics-text">No statistics</p>
      )}
    </div>
  );
};
